import $ from 'jquery';


$('.product-block__product-list__accordion__item__title').on('click' , e => {
  const accIndex = $(e.currentTarget).attr('data-accordion-index');

  $('.product-block__product-list__accordion__item').each((index, el) => {
    $(el).removeClass('is-selected');
  });

  $('.product-block__product__image').each((index, el) => {
    $(el).removeClass('active-image');
    if ($(el).attr('data-image-index') === accIndex) {
      $(el).addClass('active-image');
    }
  });
});